module.exports = __webpack_public_path__ + "img/pet_reserve.99041b85.png";